import { render, staticRenderFns } from "./CopyLinkModal.vue?vue&type=template&id=ace3a930"
import script from "./CopyLinkModal.vue?vue&type=script&lang=js"
export * from "./CopyLinkModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports